<template>
<aside>
    <div class="title">
        <h3>Últimas da UGT-SP Notícias</h3>
    </div>
    <div v-for="(noticia, index) in ultimas" :key="index">
        <div class="news">
            <a :href="noticia.id">
                <img :src="getFirstActveImage(noticia.imagens)" alt="">
            </a>
            <div class="news-container">
                <news-header></news-header>
                <p class="text" v-html="noticia.noticia.substring(0, 400)" v-if="noticia.noticia.length > 0"></p>
                <a :href="noticia.id" class="leia-mais">
                    ...Leia mais
                </a>
            </div>
        </div>
        <div class="news-separator"></div>
    </div>
</aside>
</template>

<script>
import newsHeader from './news-header.vue'
import ImagensMixin from '../../../../../mixins/images.mixin'
import axios from 'axios'
export default {
    name: 'news-aside',
    components : {
        newsHeader,
    },
    mixins: [ImagensMixin],
    props: {
        id: String,
    },
    data() {
        return {
            ultimas: [],
        }
    },
    methods: {
        buscaUltimasNoticias(id) {
           axios('get-noticia-atual/'+id)
            .then(res => {
                this.ultimas = res.data.ultimas
            })
            .catch(error => {
                console.log(error)
            })
        }
    },
    created() {
        this.buscaUltimasNoticias(parseInt(this.id))
    },
}
</script>

<style lang="scss" scoped>
aside {
    @apply w-4/12 py-0 px-4;

    @media (max-width: 768px) {
        @apply w-full  px-0;
    }

    .leia-mais {
        @apply text-black italic font-black;

        &:hover {
            @apply text-secondary;
        }
    }

    .title {
        border-bottom: 3px solid #e6242c;
        h3 {
            @apply font-bold text-black text-center uppercase text-xl;
        }
    }
    .news {
        @apply pt-8 pr-0 pb-4 pl-0;
        img {
            background: #fed843;
            width: 100%;
            height: 250px;
            object-fit: cover;
            object-position: top;
            border-radius: 10px;
        }
    }
    .news-separator {
        @apply w-full h-px bg-light-gray;
    }
    .news-separator:last-child {
        @apply hidden;
    }
    a {@apply text-black; }
    .text {
        @apply text-base;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }
}
</style>
